import React from "react";
import { Link } from "react-router-dom";
import { mediaUrl } from "@/lib/api";

// Editorial brand card linking to its dedicated company page.
export const CompanyCard = ({ brand }) => {
  const logo = mediaUrl(brand.logoMediaId || brand.logo);
  const isComing = brand.comingSoon;

  return (
    <Link
      to={`/companies/${brand.slug}`}
      data-testid="company-card"
      className="group relative flex h-full flex-col items-center rounded-[18px] px-8 py-10 text-center transition-[border-color,transform] duration-300"
      style={{ background: "var(--surface)", border: "1px solid var(--card-border)" }}
      onMouseEnter={(e) => { e.currentTarget.style.borderColor = "rgba(140,106,61,0.6)"; e.currentTarget.style.transform = "translateY(-4px)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.borderColor = "var(--card-border)"; e.currentTarget.style.transform = "none"; }}
    >
      <div className="flex h-16 items-center justify-center">
        {logo ? (
          <img src={logo} alt={`${brand.name} logo`} className="max-h-14 max-w-[150px] object-contain" loading="lazy" />
        ) : (
          <span className="text-[26px]" style={{ color: "var(--accent)", fontWeight: 500, opacity: 0.85 }}>{brand.name?.charAt(0)}</span>
        )}
      </div>
      <h3 className="mt-6 text-[18px]" style={{ color: "var(--text)", fontWeight: 500, letterSpacing: "0.2px" }}>{brand.name}</h3>
      {brand.industry && (
        <p className="mt-2 text-[11px] uppercase" style={{ color: "var(--fg-subtle)", letterSpacing: "0.18em" }}>{brand.industry}</p>
      )}
      <p className="mx-auto mt-4 max-w-[38ch] text-[14px] leading-[1.8]" style={{ color: "var(--muted)" }}>{brand.description}</p>
      <span
        data-testid="company-card-cta"
        className="mt-6 text-[11px] uppercase"
        style={{ color: "var(--accent)", letterSpacing: "0.2em" }}
      >
        {isComing ? "Coming Soon" : "View Company →"}
      </span>
    </Link>
  );
};
